<template>
  <div class="gx-sg custom-el-wrapper">
    <!-- 搜索区 -->
    <div class="gx-sg__search">
      <div class="gx-sg_search-row">
        <el-select v-model="searchType" size="small" style="width: 80px">
          <el-option value="" label="宝贝"></el-option>
        </el-select>
        <div class="gx-sg__search-box">
  <!--        <svg width="15" height="15" viewBox="0 0 15 15" fill="none"><circle cx="6.5" cy="6.5" r="4.5" stroke="#6A6A8A" stroke-width="1.3" /><path d="M10.5 10.5L14 14" stroke="#6A6A8A" stroke-width="1.4" stroke-linecap="round" /></svg>-->
          <input v-model="searchParams.name" placeholder="输入关键字搜索商品" @keyup.enter="search(1)" />
        </div>
        <button class="gx-sg__search-btn" @click="search(1)">搜索</button>
      </div>
    </div>

    <!-- 筛选区 -->
    <div class="gx-sg__filter">
      <div class="gx-sg__row">
        <span class="gx-sg__label">平台</span>
        <div class="gx-sg__chip-row">
          <button
            v-for="p in platforms"
            :key="p.value"
            class="gx-sg__chip"
            :class="{ 'gx-sg__chip--on': platformType === p.value }"
            @click="switchPlatform(p.value)"
          >{{ p.label }}</button>
        </div>
      </div>
      <div class="gx-sg__row">
        <span class="gx-sg__label">类目</span>
        <div class="gx-sg__chip-row">
          <button
            class="gx-sg__chip"
            :class="{ 'gx-sg__chip--on': !searchParams.category_one }"
            @click="selectCate(null)"
          >全部</button>
          <button
            v-for="cate in cateGroupList"
            :key="cate.id"
            class="gx-sg__chip"
            :class="{ 'gx-sg__chip--on': searchParams.category_one === cate.id }"
            @click="selectCate(cate)"
          >{{ cate.name }}</button>
        </div>
      </div>
      <div v-if="subCateList.length" class="gx-sg__row">
        <span class="gx-sg__label">分类</span>
        <div class="gx-sg__chip-row">
          <button
            class="gx-sg__chip"
            :class="{ 'gx-sg__chip--on': !searchParams.category_two }"
            @click="selectSubCate(null)"
          >全部</button>
          <button
            v-for="cate in subCateList"
            :key="cate.id"
            class="gx-sg__chip"
            :class="{ 'gx-sg__chip--on': searchParams.category_two === cate.id }"
            @click="selectSubCate(cate)"
          >{{ cate.name }}</button>
        </div>
      </div>
    </div>

    <div class="gx-sg__filter area-row">
      <span class="gx-sg__filter-label">排序方式</span>
      <el-select v-model="searchParams.sort_type" clearable placeholder="综合排序" size="mini" @change="search(1)" style="width: 150px;">
        <el-option label="价格从低到高" value="price-asc"/>
        <el-option label="价格从高到低" value="price-desc"/>
        <el-option label="浏览量从低到高" value="view-asc"/>
        <el-option label="浏览量从高到低" value="view-desc"/>
        <el-option label="上新时间从远到近" value="create-asc"/>
        <el-option label="上新时间从近到远" value="create-desc"/>
      </el-select>
      <span class="gx-sg__filter-label">价格区间</span>
      <div class="gx-sg__money-rang">
      <span class="gx-sg__money-unit">￥</span>
        <input class="gx-sg__money-input" type="number" v-model="searchParams.min_price" />
        <span>-</span>
        <span class="gx-sg__money-unit">￥</span>
        <input class="gx-sg__money-input" type="number" v-model="searchParams.max_price" />
      </div>
      <button class="gx-sg__btn gx-sg__btn-sure" @click="search()">确定</button>
      <button class="gx-sg__reset" @click="reset()">重置</button>
      <label class="gx-sg__check" @click="toggleSelectAll">
        <div class="gx-sg__check-box" :class="{'gx-sg__check-box--on':isAllSelected}">
          <svg v-if="isAllSelected" width="8" height="8" viewBox="0 0 8 8" fill="none" data-fg-czgg18=":0:/src/app/pages/SelectionPage.tsx:77:21:5194:161:e:svg:e"><path d="M1 4l2 2 4-4" stroke="#F0F2F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-fg-czgg19=":0:/src/app/pages/SelectionPage.tsx:77:77:5250:99:e:path"></path></svg>
        </div>
        <span>全选</span>
      </label>
      <button class="gx-sg__btn gx-sg__btn-add" @click="batchAddToCloud()">+ 加入云商品库</button>
      <span class="gx-sg__filter-label gx-sg__total">共找到 <b style="color: rgb(212, 169, 70)" >{{ pageData.total }}</b> 件商品</span>

    </div>

    <!-- 商品网格 -->
    <div v-if="list.length" class="gx-sg__grid">
      <div v-for="(g, i) in list" :key="g.product_id || g.id" class="gx-sg__card" >
        <div class="gx-sg__card-head">
          <div class="gx-sg__card-check">
            <div class="gx-sg__check-box" :class="{'gx-sg__check-box--on':selectedRows.includes(g.product_id||g.id)}">
              <svg v-if="selectedRows.includes(g.product_id||g.id)" width="8" height="8" viewBox="0 0 8 8" fill="none" data-fg-czgg18=":0:/src/app/pages/SelectionPage.tsx:77:21:5194:161:e:svg:e"><path d="M1 4l2 2 4-4" stroke="#F0F2F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-fg-czgg19=":0:/src/app/pages/SelectionPage.tsx:77:77:5250:99:e:path"></path></svg>
            </div>
            <span>{{g.product_id||g.id}}</span>
          </div>
        </div>
        <span class="gx-sg__thumb" @click="goDetail(g)">
           <img v-if="g.img" :src="g.img" alt="" />
           <span v-else>🛍️</span>
          <div class="gx-sg__card-cloud" v-if="g.in_cloud_library">已加入云商品库</div>
          <div class="gx-sg__mask">
            <div class="gx-sg__mask-tag">点击快览</div>
          </div>
        </span>
        <div class="gx-sg__card-body">
          <div class="gx-sg__name">{{ g.name || g.title || '--' }}</div>
          <div class="gx-sg__price-row">
            <span class="gx-sg__price">¥{{ g.discount_price || g.price }}</span>
            <span v-if="g.price && g.discount_price && g.price !== g.discount_price" class="gx-sg__origin">¥{{ g.price }}</span>
          </div>
          <div class="gx-sg__meta">
            <span v-if="g.shop_name" class="gx-sg__shop">{{ g.shop_name }}</span>
            <span v-if="g.ddproduct_count != null" class="gx-sg__count">已铺 {{ g.ddproduct_count }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="gx-sg__empty">暂无商品，试试其他关键词</div>

    <!-- 分页 -->
    <div class="gx-sg__pager">
      <div class="gx-sg__pager-total">
        <span>共 <span class="gx-sg__pager-total-num">{{ pageData.total }}</span> 条</span>
        <el-select size="mini" v-model="pageData.page_size" style="width: 100px;color: #1a1a2e;" @change="search(1)">
          <el-option v-for="item in [20,50,100]" :key="item" :value="item" :label="item+'条/页'"></el-option>
        </el-select>
      </div>

      <div class="gx-sg__pager-btns">
        <button class="gx-sg__page" :disabled="pageData.page <= 1" @click="search(pageData.page - 1)">上一页</button>
        <template v-for="item in pagerItems">
          <button v-if="item.type === 'page'" :key="item.key" class="gx-sg__page" :class="{ 'gx-sg__page--on': item.value === pageData.page }" @click="search(item.value)">{{ item.value }}</button>
          <button v-else :key="item.key" class="gx-sg__page gx-sg__page--more" @click="quickJump(item.dir)">···</button>
        </template>
        <button class="gx-sg__page" :disabled="pageData.page >= totalPages" @click="search(pageData.page + 1)">下一页</button>
      </div>
      <div class="gx-sg__pager-jump">
        <span>前往</span>
        <input v-model="jumpPage" placeholder="页码"/>
        <span>页</span>
        <button class="jump-btn" @click="handleCurrentChange">确定</button>
      </div>
    </div>

    <div class="gx-sg__foot">
      <div class="gx-sg__foot-item" v-for="(item,index) in footList" :key="index">
        <div class="gx-sg__foot-item-icon">{{item.icon}}</div>
        <div>
          <div class="gx-sg__foot-item-title">{{item.title}}</div>
          <div class="gx-sg__foot-item-tip">{{item.tip}}</div>
        </div>
      </div>
    </div>

    <!-- 加入云商品库 -->
    <div v-if="cloudGroupVisible" class="gx-modal" @click.self="cloudGroupVisible = false">
      <div class="gx-modal-box gx-sg__modal-box--sm">
        <div class="gx-modal-head gx-modal-head--gray ">
          <span class="gx-modal-title">加入云商品库</span>
          <button class="gx-modal-close" @click="cloudGroupVisible = false">✕</button>
        </div>
        <div class="gx-modal-body custom-form-wrap">
          <el-form size="small">
            <div class="gx-sg__sel-tag">
              <span class="gx-sg__sel-tag-dot"></span>
              <span>已选 {{selectedRows.length}} 个商品</span>
            </div>
            <el-form-item label="选择分组">
              <el-select v-model="cloudGroupId" placeholder="不选择则不加入分组" clearable style="width: 90%">
                <el-option v-for="item in cloudGroupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="gx-modal-foot">
          <button class="gx-modal-foot-btn" @click="cloudGroupVisible = false">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="cloudGroupLoading" @click="submitCloudGroup">
            {{ cloudGroupLoading ? '保存中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!--商品预览-->
    <div v-if="detailVisible" class="gx-modal" @click="detailVisible=false">
      <div class="gx-modal-box gx-sg__modal-box">
        <button class="gx-sg__modal-close">×</button>
        <div class="gx-sg__modal-body">
          <div class="gx-sg__modal-left">
            <div class="gx-as__banner">
              <img v-if="bannerList[bannerIndex]" :src="bannerList[bannerIndex]" alt="" />
              <span v-else>🛍️</span>
              <button class="gx-as__banner-btn gx-as__banner-btn--pre" v-if="bannerIndex>0">‹</button>
              <button class="gx-as__banner-btn gx-as__banner-btn--next" v-if="bannerIndex<bannerList.length">›</button>
              <div class="gx-as__banner-count">{{bannerIndex+1}}/{{bannerList.length}}</div>
            </div>
            <div class="gx-sg__imgs" >
              <div class="gx-sg__img-item" v-for="(item,index) in bannerList" :key="index" @click="bannerIndex = index">
                <img :src="item" alt="" />
              </div>
            </div>
          </div>
          <div class="gx-sg__modal-right">
            <div class="gx-sg__goods">
              <div class="gx-sg__goods-name">{{productData.title}}</div>
              <div class="gx-sg__goods-price">
                <span class="gx-sg__goods-price--current">￥{{productData.price}}</span>
<!--                <div  class="gx-sg__goods-price&#45;&#45;1688">
                  1688价格
                  <span class="gx-sg__goods-price&#45;&#45;line" style="margin-left: 5px">￥45.00</span>
                </div>-->
              </div>
<!--              <div class="gx-sg__profit">
                预计利润
                <span class="gx-sg__profit-money">￥23.00</span>
                <span style="font-size: 11px;">(毛利率 34%)</span>
              </div>-->
            </div>
            <div>
              <div class="gx-sg__title-sub">商品属性</div>
              <div class="gx-sg__propertys">
                <div class="gx-sg__property-item" v-for="(format,index) in formatList" :key="index">
                  <span class="gx-sg__property-item-label">{{ format.PropertyName }}</span>
                  <span class="gx-sg__property-item-val">{{ format.Name || '—' }}</span>
                </div>
              </div>
            </div>
            <div class="gx-sg__modal-right-divide"></div>
            <div>
              <div class="gx-sg__title-sub">SKU列表</div>
              <div class="gx-sg__sku">
                <div class="gx-sg__sku-row gx-sg__sku-head">
                  <span v-for="item in ['图','SKU名称','价格','库存']" :key="item">{{item}}</span>
                </div>
                <div class="gx-sg__sku-row" v-for="(item,index) in skuList" :key="index">
                  <div>
                    <img :src="item.image_url" v-if="item.image_url" class="gx-sg__sku-img"/>
                    <div class="gx-sg__sku-img" v-else></div>
                  </div>
                  <span class="gx-sg__sku-name">{{item?.attributes?.text??''}}</span>
                  <span class="gx-sg__sku-price">￥{{item.price}}</span>
                  <span class="gx-sg__sku-stock">{{item.stock}}</span>
                </div>
                <div class="gx-sg__sku-empty" v-if="!skuList.length">暂无SKU</div>
              </div>
<!--              <div class="gx-sg__table-sku">
                <table>
                  <thead>
                    <tr>
                      <th v-for="item in ['图','SKU名称','价格','库存']" :key="item">{{item}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in skuList" :key="index">
                      <td>
                        <img :src="item.image_url" v-if="item.image_url" class="gx-sg__table-sku-img"/>
                      </td>
                      <td>{{item?.attributes?.text??''}}</td>
                      <td>
                        <strong class="" style="color:var(&#45;&#45;gx-gold)">￥{{item.price}}</strong>
                      </td>
                      <td>
                        <span class="gx-sg__table-sku-stock">{{item.stock}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>-->
            </div>
          </div>
        </div>
        <div class="gx-sg__modal-foot">
          <span class="gx-sg__modal-foot-link">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M5 2H2a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"></path>
              <path d="M8 1h4v4M12 1L6.5 6.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            1688链接
          </span>
          <button class="gx-sg__modal-foot-btn gx-sg__modal-foot-btn--yellow" @click="addCloud">+ 加入云商品库</button>
          <button class="gx-sg__modal-foot-btn gx-sg__modal-foot-btn--blue">✨ AI生成标题</button>
          <button class="gx-sg__modal-foot-btn gx-sg__modal-foot-btn--blue">🖼️ AI生成主图</button>
          <button class="gx-sg__modal-foot-btn" @click="detailVisible=false">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { addToCloudProduct } from '../../api/main/index'
import {cloudProductGroups} from '../../api/main/ucenter';

export default {
  name: 'NewSelectGoodsPage',
  data() {
    return {
      searchType:'',
      platforms: [
        { value: 1, label: '抖店' },
        { value: 7, label: '微店' }
      ],
      platformType: 1,
      searchParams: { name: '', category_one: 0, category_two: 0, sort_type:'' },
      selectedRows:[],
      cateGroupList: [],
      subCateList: [],
      sortOptions: [
        { label: '综合排序', val: 0 },
        { label: '新品', val: 1 },
        { label: '销量', val: 2 },
        { label: '人气', val: 3 }
      ],
      list: [],
      pageData: { page: 1, page_size: 20, total: 0 },
      cloudAdding: false,
      cloudGroupId:'',
      cloudGroupLoading: false,
      cloudGroupVisible:false,
      cloudGroupList:[],
      jumpPage:'',
      footList:[
        {icon:'✅',title:'质量保障',tip:'品质行货 放心选购'},
        {icon:'💰',title:'价格实惠',tip:'普惠时价 帮你省钱'},
        {icon:'📦',title:'品类齐全',tip:'助您轻松购物'},
        {icon:'🚀',title:'准时送到',tip:'收货时间由你做主'},
      ],
      //商品详情
      detailVisible:false,
      productData:{},
      skuList:[],
      bannerList:[],
      bannerIndex:0,
      formatList:[]
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.page_size))
    },
    pagerItems() {
      const total = this.totalPages
      const current = this.pageData.page
      const pagerCount = 7
      if (total <= pagerCount) {
        const items = []
        for (let i = 1; i <= total; i++) items.push({ type: 'page', value: i, key: 'p' + i })
        return items
      }
      const showPrevMore = current > pagerCount - 2
      const showNextMore = current < total - 3
      let middles = []
      if (showPrevMore && showNextMore) {
        for (let i = current - 2; i <= current + 2; i++) middles.push(i)
      } else if (showPrevMore) {
        for (let i = total - (pagerCount - 2); i < total; i++) middles.push(i)
      } else if (showNextMore) {
        for (let i = 2; i < pagerCount; i++) middles.push(i)
      } else {
        for (let i = 2; i < total; i++) middles.push(i)
      }
      const items = [{ type: 'page', value: 1, key: 'p1' }]
      if (showPrevMore) items.push({ type: 'more', dir: 'prev', key: 'more-prev' })
      middles.forEach(n => items.push({ type: 'page', value: n, key: 'p' + n }))
      if (showNextMore) items.push({ type: 'more', dir: 'next', key: 'more-next' })
      items.push({ type: 'page', value: total, key: 'pt' + total })
      return items
    },
    isAllSelected() {
      return this.list.length > 0 && this.selectedRows.length === this.list.length
    },
  },
  created() {
    this.getCateList()
    this.search(1)
  },
  methods: {
    ...mapActions({
      getMallCateData: 'index/getMallCateData',
      getMallProductList: 'index/getMallProductList',
      getProductDetail: "index/getProductDetail",
    }),

    getCateList() {
      this.getMallCateData({
        data: { shop_type: this.platformType },
        success: (res) => {
          if (res.code === 200 && res.data && res.data.length > 0) {
            this.cateGroupList = res.data
            this.subCateList = this.cateGroupList[0] ? (this.cateGroupList[0].children || []) : []
          } else {
            this.cateGroupList = []
            this.subCateList = []
          }
        }
      })
    },
    switchPlatform(p) {
      this.platformType = p
      this.searchParams.category_one = 0
      this.searchParams.category_two = 0
      this.getCateList()
      this.search(1)
    },
    selectCate(cate) {
      this.searchParams.category_one = cate ? cate.id : 0
      this.searchParams.category_two = 0
      this.subCateList = cate ? (cate.children || []) : (this.cateGroupList[0] ? (this.cateGroupList[0].children || []) : [])
      this.search(1)
    },
    selectSubCate(cate) {
      this.searchParams.category_two = cate ? cate.id : 0
      this.search(1)
    },

    search(page) {
      this.pageData.page = page
      const param = {
        page_size: this.pageData.page_size,
        page: this.pageData.page,
        state: 1,
        shop_type: this.platformType
      }
      Object.assign(param, this.searchParams)
      this.getMallProductList({
        data: param,
        success: (res) => {
          if (res.code === 200) {
            this.list = res.data.list || []
            // this.list = [{id:'3841521079621386518'}]
            this.pageData.total = res.data.pagination ? (res.data.pagination.total || 0) : 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    reset() {
      this.searchParams.category_one = ''
      this.searchParams.category_two = ''
      this.searchParams.sort_type = ''
      this.search()
    },
    handleCurrentChange(){
      const num = Math.floor(Number(this.jumpPage))
      const current = num > this.totalPages ? this.totalPages : num > 0 ? num : 1
      this.$set(this.pageData,'page',current)
      this.jumpPage=''
      this.search(current)
    },
    quickJump(dir) {
      const target = dir === 'prev' ? Math.max(1, this.pageData.page - 5) : Math.min(this.totalPages, this.pageData.page + 5)
      if (target !== this.pageData.page) this.search(target)
    },

    toggleSelectAll() {
      this.selectedRows = this.isAllSelected ? this.list.map(i=>i.product_id||i.id) : []
    },
    /**
     * —— 商品详情 —— */
    goDetail(g){
      // this.$router.push({ path: '/detail', query: { id: g.product_id || g.id } })
      this.getProductDetail({
        data: {product_id: g.product_id || g.id}, success: (res) => {
          if (res.code === 200) {
            this.productData = res.data.product?JSON.parse(JSON.stringify(res.data.product)):{}
            this.skuList = res.data.skus?JSON.parse(JSON.stringify(res.data.skus)):[]
            this.bannerList = res.data?.images?.slider??[]
            // this.bannerList = res.data?.main_images??[]
            this.detailPicList = res.data.images.detail

            let flist = res.data.product.dy_format
            let formatList = []
            for (let key in flist) {
              formatList.push(flist[key][0])
            }
            this.formatList = formatList
            this.detailVisible = true
          } else {
            this.$message({message: res.message, type: 'error',});
          }
        }
      })
    },
    /**
     * —— 云商品库 ——*/
    addCloud() {
      const g = {...this.productData}
      if (this.cloudAdding || g.in_cloud_library) return
      this.cloudAdding = true
      addToCloudProduct({ product_ids: [g.product_id || g.id] }).then((res) => {
        this.cloudAdding = false
        if (res.code === 200) {
          this.$message.success(res.message || '加入成功')
          g.in_cloud_library = true
        } else {
          this.$message.error(res.message || '加入失败')
        }
      }).catch(() => {
        this.cloudAdding = false
      })
    },
    batchAddToCloud() {
      if (this.selectedRows.length == 0) {
        this.$message({ message: '请先勾选商品', type: 'warning' });
        return
      }
      this.cloudGroupId = ''
      this.cloudGroupVisible = true
      this.loadCloudGroupList()
    },
    loadCloudGroupList() {
      if (this.cloudGroupList.length > 0) return
      this.cloudGroupLoading = true
      cloudProductGroups({ with_count: 0 }).then(res => {
        this.cloudGroupLoading = false
        if (res.code === 200) {
          this.cloudGroupList = res.data || []
        }
      }).catch(() => { this.cloudGroupLoading = false })
    },
    submitCloudGroup() {
      const loading = this.$loading({lock: true, text: '正在加入云商品库...', background: 'rgba(0, 0, 0, 0.7)'})
      const params = { product_ids: this.selectedRows }
      if (this.cloudGroupId) params.group_id = this.cloudGroupId
      addToCloudProduct(params).then(res => {
        loading.close()
        if (res.code === 200) {
          this.$message({message: res.message || '加入成功', type: 'success'});
          this.cloudGroupVisible = false
        } else {
          this.$message({message: res.message, type: 'error'});
        }
      }).catch(() => { loading.close() })
    },
  }
}
</script>

<style scoped>
.area-row{
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}
.gx-sg {
  font-family: 'Noto Sans SC', sans-serif;
}
.gx-sg__search {
  background: rgb(243, 245, 250);
  backdrop-filter: none;
  border: 1px solid rgb(221, 226, 236);
  border-radius: 10px;
  box-shadow: rgba(15, 23, 42, 0.04) 0px 1px 4px;
  padding: 12px 14px;
  margin-bottom: 12px;
}
.gx-sg_search-row{
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.gx-sg__search-box {
  flex: 1 1 0%;
  height: 36px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0px 12px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(221, 226, 236);
  border-radius: 5px;
  box-sizing: border-box;
}
.gx-sg__search-box:focus-within {
  border-color: rgba(212, 169, 70, .65);
}
.gx-sg__search-box input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  color: #1A1A2E;
  background: none;
}
.gx-sg__search-box input::placeholder {
  color: rgb(140, 140, 150);
}
.gx-sg__search-btn {
  height: 38px;
  padding: 0 24px;
  border-radius: 8px;
  cursor: pointer;
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-sg__filter {
  background: rgb(243, 245, 250);
  backdrop-filter: none;
  border: 1px solid rgb(221, 226, 236);
  border-radius: 10px;
  box-shadow: rgba(15, 23, 42, 0.04) 0px 1px 4px;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: 12px;
}
.gx-sg__filter-label{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(74, 74, 106);
  white-space: nowrap;
}
.gx-sg__btn{
  height: 26px;
  padding: 0px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 400;
  background:#ffffff;
  transition: 0.2s;
  white-space: nowrap;
}
.gx-sg__btn-sure{
  background: transparent;
  border: 1px solid rgba(63, 182, 224, 0.4);
  color: rgb(63, 182, 224);
}
.gx-sg__btn-add{
  font-weight: 600;
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 193, 112));
  color: rgb(240, 242, 248);
}
.gx-sg__row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}
.gx-sg__row:last-child {
  margin-bottom: 0;
}
.gx-sg__label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  line-height: 22px;
  color: rgb(74, 74, 106);
  min-width: 28px;
  flex-shrink: 0;
}
.gx-sg__chip-row{
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1 1 0%;
}
.gx-sg__chip {
  height: 22px;
  padding: 0px 8px;
  border-radius: 3px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  background: transparent;
  border: 1px solid rgb(221, 226, 236);
  color: rgb(74, 74, 106);
  transition: 0.14s;
  white-space: nowrap;
}
.gx-sg__chip--on {
  background: rgba(212, 169, 70, 0.094);
  border: 1px solid rgb(212, 169, 70);
  color: rgb(212, 169, 70);
}
.gx-sg__money-rang{
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: rgb(74, 74, 106);
}
.gx-sg__money-unit{
  color: rgb(212, 169, 70);
}
.gx-sg__money-input{
  width: 58px;
  height: 26px;
  padding: 0px 6px;
  border-radius: 4px;
  border: 1px solid rgb(221, 226, 236);
  background: rgb(255, 255, 255);
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  color: rgb(26, 26, 46);
  outline: none;
}
.gx-sg__reset{
  color:#4a4a6a;
  font-size: 12px;
  cursor: pointer;
}
.gx-sg__check{
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: rgb(74, 74, 106);
}
.gx-sg__check-box{
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
  background: rgb(255, 255, 255);
  border: 1.5px solid rgb(221, 226, 236);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.gx-sg__check-box--on{
  border: 1.5px solid transparent;
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 193, 112));
}

.gx-sg__modal-box--sm{
  max-width: 400px;
}

.gx-sg__sel-tag{
  width: max-content;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  background: rgb(255, 248, 230);
  border: 1px solid rgba(212, 169, 70, 0.4);
  font-size: 11px;
  color: rgb(212, 169, 70);
  font-weight: 500;
}
.gx-sg__sel-tag-dot{
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgb(212, 169, 70);
}
.gx-sg__total {
  margin-left: auto;
}

.gx-sg__grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  margin-bottom: 8px;
}
.gx-sg__card {
  background: rgb(243, 245, 250);
  backdrop-filter: none;
  border: 1px solid rgb(221, 226, 236);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: rgba(15, 23, 42, 0.08) 0 2px 8px;
  transition: border 0.2s, box-shadow 0.2s;
}
.gx-sg__card:hover {
  border: 1px solid rgba(212,169,70,0.38);
  box-shadow: rgba(15, 23, 42, 0.16) 0 10px 24px;
}
.gx-sg__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px 4px;
}
.gx-sg__card-check{
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
  color: rgb(74, 74, 106);
}
.gx-sg__card-cloud{
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(63, 182, 224, 0.2);
  border: 1px solid rgba(63, 182, 224, 0.4);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(63, 182, 224);
  white-space: nowrap;
}

.gx-sg__thumb {
  position: relative;
  margin: 4px 10px;
  height: 152px;
  border-radius: 6px;
  overflow: hidden;
  background: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-in;
}
.gx-sg__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-sg__mask{
  position: absolute;
  inset: 0px;
  background: rgba(15,23,42,0.22);
  justify-content: center;
  align-items: center;
  display: none;
}
.gx-sg__mask-tag{
  width: max-content;
  color: #ffffff;
  font-size: 10px;
  letter-spacing: .1em;
  padding: 5px 10px;
  border-radius: 4px;
  background: rgba(15, 23, 42, 0.6);
}
.gx-sg__card:hover .gx-sg__mask{
  display: flex;
}
.gx-sg__card-body {
  padding: 8px 10px 10px;
}
.gx-sg__name {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color: rgb(26, 26, 46);
  line-height: 1.4;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gx-sg__price-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 4px;
}
.gx-sg__price {
  font-family: "JetBrains Mono", monospace;
  font-size: 15px;
  font-weight: 600;
  color: rgb(212, 169, 70);

}
.gx-sg__origin {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #999;
  text-decoration: line-through;
}
.gx-sg__meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(74, 74, 106);
}

.gx-sg__ops {
  display: flex;
  gap: 6px;
}
.gx-sg__op {
  flex: 1;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  border: 1px solid #DDE2EC;
  background: #FFFFFF;
  color: #4A4A6A;
  transition: all .15s;
}
.gx-sg__op--gold {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-sg__op:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-sg__empty {
  text-align: center;
  padding: 64px 0;
  border-radius: 10px;
  background: #F3F5FA;
  border: 1px solid #DDE2EC;
  color: #6A6A8A;
  margin-bottom: 8px;
}
.gx-sg__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(74, 74, 106);
}
.gx-sg__pager-total {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-sg__pager-total-num{
  font-weight: 700;
  color: rgb(212, 169, 70);
}
.gx-sg__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-sg__page {
  min-width: 28px;
  height: 28px;
  padding: 0px 10px;
  border-radius: 4px;
  border: 1px solid rgb(221, 226, 236);
  background: rgb(255, 255, 255);
  cursor: pointer;
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  color: rgb(74, 74, 106);
  transition: 0.15s;
  box-sizing: border-box;
}
.gx-sg__page:hover{
  border: 1px solid rgb(212, 169, 70);
  color: rgb(212, 169, 70);
}
.gx-sg__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-sg__page--more {
  border-color: transparent;
  background: transparent;
}
.gx-sg__page--more:hover {
  border-color: transparent;
  color: rgb(212, 169, 70);
}
.gx-sg__page--on {
  border: 1px solid rgb(212, 169, 70);
  background: rgb(225, 229, 238);
  color: rgb(212, 169, 70);
}
.gx-sg__pager-jump{
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-sg__pager-jump input{
  width: 48px;
  height: 28px;
  padding: 0 6px;
  border-radius: 4px;
  border: 1px solid rgb(221, 226, 236);
  background: rgb(255, 255, 255);
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  color: rgb(26, 26, 46);
  outline: none;
  text-align: center;
  box-sizing: border-box;
}
.gx-sg__pager-jump .jump-btn{
  height: 28px;
  padding: 0px 12px;
  border-radius: 4px;
  border: 1px solid rgb(212, 169, 70);
  background: rgb(225, 229, 238);
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(212, 169, 70);
  transition: 0.15s;
}
.gx-sg__pager-jump .jump-btn:hover{
  background: rgb(212, 169, 70);
  color: #FFFFFF;
}

.gx-sg__foot{
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid rgb(221, 226, 236);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.gx-sg__foot-item{
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: rgb(244, 246, 250);
  border-radius: 8px;
  border: 1px solid rgb(221, 226, 236);
  font-family: "Noto Sans SC", sans-serif;
}
.gx-sg__foot-item-icon{
  font-size: 20px;
}
.gx-sg__foot-item-title{
  font-size: 13px;
  font-weight: 600;
  color: rgb(212, 169, 70);
}
.gx-sg__foot-item-tip{
  font-size: 11px;
  color: rgb(74, 74, 106);
}

/* —— 商品详情弹窗 —— */
.gx-sg__modal-box{
  width: 100%;
  max-width: 920px;
  height: 620px;
  border-radius: 16px;
  background: linear-gradient(160deg, rgba(18, 32, 60, 0.97) 0%, rgba(11, 20, 38, 0.97) 100%);
  border: 1px solid rgba(212, 169, 70, 0.15);
  box-shadow: rgba(0, 0, 0, 0.8) 0px 32px 80px, rgba(212, 169, 70, 0.06) 0px 0px 60px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.gx-sg__modal-close{
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 20;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  color: rgb(156, 163, 181);
  font-size: 16px;
  transition: 0.2s;
}
.gx-sg__modal-close:hover{
  background: rgba(232,92,92,0.15);
  border-color: rgba(232,92,92,0.4);
  color: rgba(232,92,92);
}
.gx-sg__modal-body{
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex: 1 1 0%;
  overflow: hidden;
}
.gx-sg__modal-left{
  padding: 24px 20px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-right: 1px solid rgba(212, 169, 70, 0.15);
}
.gx-sg__modal-right{
  flex: 1 1 0%;
  overflow-y: auto;
  padding: 20px 20px 12px;
  scrollbar-width: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.gx-sg__modal-right-divide{
  border-radius: 9px;
  border: 1px solid rgba(63, 182, 224, 0.2);
  background: rgba(63, 182, 224, 0.04);
  overflow: hidden;
}
.gx-sg__modal-foot{
  display: flex;
  align-items: center;
  padding: 12px 24px;
  border-top: 1px solid rgba(212, 169, 70, 0.15);
  background: rgba(10, 18, 36, 0.6);
  backdrop-filter: none;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 8px;
}
.gx-sg__modal-foot-link{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgb(63, 182, 224);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-right: auto;
}
.gx-sg__modal-foot-btn{
  height: 36px;
  padding: 0px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 400;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgb(156, 163, 181);
  transition: 0.2s;
  white-space: nowrap;
}
.gx-sg__modal-foot-btn:hover{
  background: rgba(255,255,255,0.7);
  color: rgb(74,74,106);
}
.gx-sg__modal-foot-btn--blue{
  border: 1px solid rgba(63, 182, 224, 0.4);
  color: rgb(63, 182, 224);
}
.gx-sg__modal-foot-btn--blue:hover{
  border-color:rgb(63, 182, 224) ;
}
.gx-sg__modal-foot-btn--yellow, gx-sg__modal-foot-btn--yellow:hover{
  font-weight: 600;
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 193, 112));
  color: rgb(244, 246, 248);
}
/*轮播图*/
.gx-as__banner{
  flex: 1 1 0%;
  position: relative;
  background: rgb(247, 248, 250);
  backdrop-filter: none;
  border: 1px solid rgba(212, 169, 70, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.gx-as__banner-btn{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: rgba(11, 20, 38, 0.7);
  border: 1px solid rgba(212, 169, 70, 0.15);
  cursor: pointer;
  color: rgb(156, 163, 181);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-as__banner-btn--next{
  right: 8px;
}
.gx-as__banner-btn--pre{
  left: 8px;
}
.gx-as__banner-count{
  position: absolute;
  bottom: 10px;
  right: 12px;
  padding: 3px 10px;
  border-radius: 20px;
  background: rgba(11, 20, 38, 0.8);
  border: 1px solid rgba(212, 169, 70, 0.15);
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
  color: rgb(156, 163, 181);
}
.gx-sg__imgs{
  display: flex;
  gap: 8px;
  justify-content: center;
  width: 100%;
  overflow-x: auto;
  min-height: 56px;
}
.gx-sg__img-item{
  width: 56px;
  height: 56px;
  border-radius: 7px;
  background: rgb(247, 248, 250);
  border: 2px solid rgba(212, 169, 70, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  cursor: pointer;
  flex-shrink: 0;
  transition: border 0.2s;
}
.gx-as__banner img,
.gx-sg__img-item img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gx-sg__goods-name{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: rgb(240, 230, 210);
  margin-bottom: 12px;
  line-height: 1.5;
  padding-right: 32px;
}
.gx-sg__goods-price{
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.gx-sg__goods-price--current{
  font-family: "JetBrains Mono", monospace;
  font-size: 26px;
  font-weight: 700;
  color: rgb(212, 169, 70);
  line-height: 1;
}
.gx-sg__goods-price--1688{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color: rgb(156, 163, 181);
}
.gx-sg__goods-price--line{
  text-decoration: line-through;
}

.gx-sg__profit{
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 7px;
  background: rgb(245, 240, 232);
  border: 1px solid rgb(225, 229, 238);
  width: fit-content;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(156, 163, 181);
}
.gx-sg__profit-money{
  font-family: "JetBrains Mono", monospace;
  font-size: 14px;
  font-weight: 600;
  color: rgb(212, 169, 70);
}
.gx-sg__title-sub{
  position: relative;
  margin-bottom: 9px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  line-height: 19px;
  font-weight: 600;
  color: rgb(212, 169, 70);
  padding-left: 9px;
}
.gx-sg__title-sub::before{
  content: "";
  position: absolute;
  top: 3px;
  left: 0;
  width: 3px;
  height: 13px;
  border-radius: 2px;
  background: linear-gradient(rgb(212, 169, 70), rgb(232, 193, 112));
}
.gx-sg__propertys{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 8px;
}
.gx-sg__property-item{
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 6px;
  background: rgb(247, 248, 250);
  border: 1px solid rgba(212, 169, 70, 0.07);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
}
.gx-sg__property-item-label{
  color: rgb(156, 163, 181);
  min-width: 38px;
}
.gx-sg__property-item-val{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(74, 74, 106);
}
.gx-sg__sku{
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(212, 169, 70, 0.15);
}
.gx-sg__sku-row {
  display: grid;
  grid-template-columns: 44px 1fr 80px 50px;
  gap: 4px;
  padding: 6px 10px;
  background: #ffffff;
  border-bottom: 1px solid rgba(212, 169, 70, 0.15);
  font-size: 12px;
}
.gx-sg__sku-head{
  background: rgba(10, 20, 42, 0.5);
  font-size: 11px;
  font-weight: 600;
  color: rgb(156, 163, 181);
}
.gx-sg__sku-img{
  width: 36px;
  height: 36px;
  border-radius: 5px;
  background: rgba(224, 92, 1220.8);
  border: 1px solid rgba(255, 255, 255, 0.12);
  object-fit: cover;
}
.gx-sg__sku-name{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(74, 74, 106);
  padding-left: 2px;
}
.gx-sg__sku-price{
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  font-weight: 600;
  color: var(--gx-gold);
}
.gx-sg__sku-stock{
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
  color: rgb(156, 163, 181);
}
.gx-sg__sku-empty{
  text-align: center;
  padding: 20px 10px;
  color: #999999;
  font-size: 12px;
}

@media (max-width: 1200px) {
  .gx-sg__grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 900px) {
  .gx-sg__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
